const acceptImg = 'image/*';
const acceptPdf = 'application/pdf';
const acceptDocx =
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
const acceptXlsx =
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
const acceptPptx =
    'application/vnd.openxmlformats-officedocument.presentationml.presentation';
const acceptVideo = 'video/*';
const acceptAudio = 'audio/*';

export const extensionImg = [
    'image/png',
    'image/jpeg',
    'image/gif',
    'image/webp',
];
const extensionPdf = ['application/pdf'];
const extensionDocx = [
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
];
const extensionXlsx = [
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
];
const extensionPptx = [
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
];
const extensionVideo = ['video/mp4', 'video/webm', 'video/avi', 'video/mkv'];
const extensionAudio = ['audio/mp3', 'audio/wav', 'audio/mpeg'];

export function getExtensionFiles(acceptArg?: string[]) {
    let accept: string[] | null = [];
    let extension: string[] | null = [];

    if (!acceptArg) return { accept: null, extension: null };

    for (const type of acceptArg) {
        if (!type) {
            accept = null;
            extension = null;
            break;
        }

        switch (type) {
            case 'image':
                accept.push(acceptImg);
                extension.push(...extensionImg);
                break;
            case 'pdf':
                accept.push(acceptPdf);
                extension.push(...extensionPdf);
                break;
            case 'docx':
                accept.push(acceptDocx);
                extension.push(...extensionDocx);
                break;
            case 'xlsx':
                accept.push(acceptXlsx);
                extension.push(...extensionXlsx);
                break;
            case 'pptx':
                accept.push(acceptPptx);
                extension.push(...extensionPptx);
                break;
            case 'video':
                accept.push(acceptVideo);
                extension.push(...extensionVideo);
                break;
            default:
                accept.push(acceptAudio);
                extension.push(...extensionAudio);
                break;
        }
    }

    return {
        accept: accept?.toString(),
        extension: extension ?? undefined,
    };
}
